import { render } from "./TrainingProgramWorkflowComponent.vue?vue&type=template&id=364a6a00&scoped=true"
import script from "./TrainingProgramWorkflowComponent.vue?vue&type=script&lang=js"
export * from "./TrainingProgramWorkflowComponent.vue?vue&type=script&lang=js"

import "./TrainingProgramWorkflowComponent.vue?vue&type=style&index=0&id=364a6a00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a6a00"]])

export default __exports__